import Button from './src/button';

Button.install = function(Vue) {
  Vue.component(Button.name, Button);
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/button/index.js